import { ChannelMemberUserTypeEnum } from '@src/enum/ChannelMemberUserTypeEnum';
import logger from '@src/utils/logger';

import {
  Attachment,
  decryptData,
  Draft,
  DRAFT_STORE_NAME,
  encryptData,
  getDbPromise,
} from './common';

export async function saveChatDraft(
  channelCode: string,
  message: string,
  attachments: Attachment[] = [],
  userType?: ChannelMemberUserTypeEnum,
  userId?: number,
): Promise<void> {
  if (!channelCode || !userType || !userId) {
    return;
  }
  const db = await getDbPromise();

  // SSR対応
  if (!db) {
    return;
  }

  const draft: Draft = {
    channelCode,
    message,
    attachments,
    updatedAt: Date.now(),
    userType,
    userId,
  };

  const encrypted = await encryptData(JSON.stringify(draft));
  try {
    await db.put(DRAFT_STORE_NAME, {
      channelCode,
      userType,
      userId,
      encrypted,
    });
  } catch (error) {
    logger.error('indexedDB Save Error during database operation:', error);
  }
}

export async function loadChatDraft(
  channelCode: string,
  currentUserType: ChannelMemberUserTypeEnum,
  currentUserId: number,
): Promise<Draft | undefined> {
  if (!currentUserType || !currentUserId) {
    return undefined;
  }
  const db = await getDbPromise();
  if (!db) {
    return undefined;
  }

  const record = await db.get(DRAFT_STORE_NAME, [channelCode, currentUserType, currentUserId]);

  if (!record || !record.encrypted || !record.userType || !record.userId) {
    return undefined;
  }
  try {
    const json = await decryptData(record.encrypted);
    return JSON.parse(json) as Draft;
  } catch (error) {
    logger.error('indexedDB Load Error:', error);
    return undefined;
  }
}

export async function deleteChatDraft(
  channelCode: string,
  currentUserType: ChannelMemberUserTypeEnum,
  currentUserId: number,
): Promise<void> {
  const db = await getDbPromise();
  if (!db) {
    return;
  }

  await db.delete(DRAFT_STORE_NAME, [channelCode, currentUserType, currentUserId]);
}

export async function clearChatDrafts(): Promise<void> {
  const db = await getDbPromise();
  if (!db) {
    return;
  }

  await db.clear(DRAFT_STORE_NAME);
}
